// The Bookshelf: stories she kept from Story Maker, readable and read aloud.

import { h, clear } from '@kit/dom';
import { speak, cancelSpeech } from '@kit/tts';
import { getSave, update, subscribe } from '../state';
import { topBar, toast } from '../ui';

interface Story { title: string; text: string }

export function bookshelfScreen(root: HTMLElement) {
  const bar = topBar('Bookshelf', { back: 'house' });
  const body = h('div.stack', { style: { padding: '0 16px 24px' } });
  root.append(bar, body);
  let open: number | null = null;

  function render() {
    clear(body);
    const stories = (getSave().kept.story || []) as { t: number; data: Story }[];
    if (!stories.length) {
      body.append(h('div.card.center', null, h('h3', null, 'No stories yet'), h('p.muted', null, 'Write one in Story Maker and tap "Keep it". It will land here.')));
      return;
    }
    stories.slice().reverse().forEach((s, ri) => {
      const i = stories.length - 1 - ri;
      const d = new Date(s.t);
      const isOpen = open === i;
      body.append(h('div.card', null,
        h('div.row', { style: { cursor: 'pointer' }, onclick: () => { open = isOpen ? null : i; render(); } },
          h('div', { style: { width: '28px', height: '40px', borderRadius: '4px', background: ['#e2574c', '#4f8fe6', '#f5c542', '#5fbf6a', '#9b6be6', '#3bb3a9'][i % 6] } }),
          h('div', { style: { flex: '1' } }, h('h3', null, s.data.title || 'Untitled'), h('p.muted.small', null, `${d.toLocaleDateString()}`)),
        ),
        isOpen ? h('div.stack', { style: { marginTop: '10px' } },
          h('p', { style: { lineHeight: '1.6' } }, s.data.text),
          h('div.grid2', null,
            h('button.btn.small', { onclick: () => { cancelSpeech(); speak(`${s.data.title}. ${s.data.text}`); } }, 'Read it'),
            h('button.btn.small.ghost', { onclick: () => { if (confirm('Take this story off the shelf?')) { update(x => { x.kept.story.splice(i, 1); }); open = null; toast('Story removed.'); } } }, 'Remove'),
          ),
        ) : null,
      ));
    });
  }

  render();
  const un = subscribe(render);
  return () => { un(); cancelSpeech(); };
}
